export const AVAILABLE_AUDIO_SPEEDS = [1, 1.5, 2, 3];